import React, { useEffect, useRef, useState } from 'react';
import { STATS } from '../data/mock';

const StatsSection = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setVisible(true),
      { threshold: 0.25 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="py-16 lg:py-20 bg-gradient-to-r from-[#5b3eb5] via-[#6b46c9] to-[#7c4ec9] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px), radial-gradient(circle at 80% 30%, white 1px, transparent 1px)',
        backgroundSize: '60px 60px',
      }} />
      <div className="relative max-w-[1280px] mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className={`text-center transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="font-serif text-[42px] lg:text-[58px] font-extrabold leading-none mb-2">
                {s.value}
              </div>
              <div className="text-white/85 text-[14px] lg:text-[15px] uppercase tracking-[0.15em] font-medium">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
